<template>
  <agent-home v-if="hasPermisson(agentStatusPermission)" />
  <admin-home v-else />
</template>
<script>
import { mapGetters, mapActions } from "vuex";

import AgentHome from "./agent/dashboard/AgentHome.vue";
import AdminHome from "./admin/dashboard/AdminHome.vue";

export default {
  name: "homePage",
  components: {
    AgentHome,
    AdminHome,
  },
  data() {
    return {
      userPermission: [],
      hasCheckedActiveCall: false,
    };
  },
  methods: {
    ...mapActions(["CheckAgentActiveCall"]),
    hasPermisson(permission) {
      return this.userPermission.includes(permission);
    },
    async initHome() {
      this.userPermission = this.permissions;
    },
  },
  computed: {
    ...mapGetters(["permissions", "domain", "agentStatusPermission", "uname", "isConnected"]),
    isAgent() {
      return this.permissions?.includes(this.agentStatusPermission);
    },
  },
  watch: {
    domain() {
      this.initHome();
    },
    isConnected(newValue) {
      // Only check once on initial page load when phone connects.
      // Skip for admin/whisperer users — they have no agent call to reattach to,
      // and this endpoint re-INVITEs them into any stale whisper bridge on the PBX.
      if (newValue && this.domain && this.uname && this.isAgent && !this.hasCheckedActiveCall) {
        this.hasCheckedActiveCall = true;
        this.CheckAgentActiveCall({ domain: this.domain, uname: this.uname });
      }
    },
  },
  created() {
    if (this.domain) {
      this.initHome();
    }
  },
  mounted() {
    // Check if phone is already connected (in case it connected before mount)
    if (this.isConnected && this.domain && this.uname && this.isAgent && !this.hasCheckedActiveCall) {
      this.hasCheckedActiveCall = true;
      this.CheckAgentActiveCall({ domain: this.domain, uname: this.uname });
    }
  },
};
</script>

<style></style>
